import { Controller } from "@hotwired/stimulus";

/** Moves a work-area filter form into the matching chart header slot after Vue mounts. */
export default class extends Controller {
  static values = { slot: String };

  connect() {
    this.attempts = 0;
    this.scheduleMove();
  }

  disconnect() {
    if (this.retryId) cancelAnimationFrame(this.retryId);
  }

  scheduleMove() {
    if (this.moveFilter()) return;

    this.attempts += 1;
    if (this.attempts < 60) {
      this.retryId = requestAnimationFrame(() => this.scheduleMove());
    }
  }

  moveFilter() {
    const source = this.element.querySelector("[data-work-area-filter-content]");
    const slot = this.element.querySelector(
      `[data-work-area-filter-slot="${this.slotValue}"]`,
    );
    if (!source || !slot) return false;

    slot.appendChild(source);
    source.hidden = false;
    return true;
  }
}
